<div class="label-answered"><mat-icon>check_circle</mat-icon>解答済み</div>
